import { ARDUINO_LIBRARIES } from '@skyrover/shared/constants';

const headerToLibrary = new Map(
  ARDUINO_LIBRARIES.map((entry) => [entry.header, entry.name] as const),
);

const includePattern = /^\s*#\s*include\s*[<"]([^">]+)[">]/gm;

/** Returns Library Manager names for third-party headers referenced in the sketch. */
export function detectRequiredLibraries(sketch: string): string[] {
  const seen = new Set<string>();
  const libs: string[] = [];

  for (const match of sketch.matchAll(includePattern)) {
    const header = match[1]?.trim();
    if (!header) {
      continue;
    }
    const lib = headerToLibrary.get(header);
    if (!lib || seen.has(lib)) {
      continue;
    }
    seen.add(lib);
    libs.push(lib);
  }

  return libs.sort();
}
